import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@sib/api';
import { NotificationProvider } from '@sib/notifications';
import { TooltipProvider } from '@sib/ui';
import '@sib/ui/styles';
import i18n from '@spendbrain/config/i18n';
import { ThemeProvider } from './providers/theme-provider';
import { Router } from './router';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <NotificationProvider>
        <QueryClientProvider>
          <BrowserRouter>
            <ThemeProvider>
              <TooltipProvider
                delayDuration={0}
                skipDelayDuration={0}
                disableHoverableContent={true}
              >
                <Router />
              </TooltipProvider>
            </ThemeProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </NotificationProvider>
    </I18nextProvider>
  );
}

export default App;
